{
  "login": {
    "submit": "Submit"
  },
  "games_names": {
    "colors": "Discovering colors",
    "shapesemptyboard": "Empty the board",
    "shapes": "Discovering shapes",
    "shapescoloring": "Coloring shapes",
    "shapesdrag": "Placing shapes",
    "shapesjigsaw": "Shapes puzzle",
    "shapesmemory": "Colors",
    "shapeswhichone": "Which shape?",
    "shapestrace": "Tracing shapes",
    "shapesfalling": "Shape recognition",
    "colorscandy": "Color candies",
    "colorsmemory": "Colors",
    "balloonsempty": "Removing balloons",
    "balloonspop": "Popping balloons",
    "shapeshalf": "Half shape",
    "shapessmallorbig": "Big or small",
    "shapessmalltobig": "Big and small",
    "numbers": "Discovering numbers",
    "numbersdrag": "Placing numbers",
    "numberscounting": "One, two, three",
    "numbershowmany": "How many animals",
    "numbersfalling": "Number bubbles",
    "numbersmemory": "Colors",
    "numberssort": "The boxes",
    "numberswhichone": "Which number?",
    "shapestangram": "Shape tangram",
    "numbersrunning": "Rabbits to the train!",
    "numbersbingo": "Number bingo",
    "numbersfindthepath": "Number path",
    "numbersbalance": "Scale",
    "numberspizza": "Addition pizza",
    "numbersadd": "Adding",
    "numberssubtract": "Subtracting",
    "animalsmemory": "Colors",
    "animalswhichone": "Which animal?",
    "animals": "Discovering animals",
    "animalssounds": "Listen to the fauna",
    "animalsmixthem": "Mix the animal",
    "animalsbingo": "Animal bingo",
    "animalsdragtoplace": "Animal silhouettes",
    "animalsfood": "Feed the animals",
    "animalsrunning": "Animals on board!",
    "animalsconnect": "Drawing with dots",
    "animalsjigsaw": "Animal puzzle",
    "numberstrace": "Tracing numbers",
    "animalsmatchfood": "Animal and food",
    "lettersmatchupperlower": "Matching letters",
    "letters": "Discovering letters",
    "lettersmissing": "Fill in the blank",
    "letterssort": "Sort the letters",
    "lettersjigsawslider": "Home jigsaw",
    "letterstraceupper": "Tracing uppercase letters",
    "letterstracelower": "Tracing lowercase letters",
    "letterschoosecorrect": "That's the word!",
    "lettersmemory": "Colors",
    "lettersmatchimage": "Object and letter",
    "lettersbingo": "Letter bingo",
    "lettersdrag": "Placing letters",
    "lettersupperfindthepath": "Letter path",
    "musicalinstruments": "Musical instruments",
    "musicplayinstruments": "Let's compose!",
    "animalsbrowse": "Check out this animal",
    "musichero": "Follow the song",
    "musicnotesfalling": "Falling notes",
    "letterscollectstuff": "Things at home",
    "numberssnake": "The number worm",
    "numbersdressbigsmall": "Big bear, small monkey",
    "numberssupermarket": "A day at the supermarket",
    "animalssoundsgrid": "Sound fauna",
    "castlepatterns": "The pattern castle",
    "numbersaddscales": "Addition scale",
    "bodydiscovery": "Face and body",
    "numbersspaceship": "The number spaceship",
    "transport": "Discovering transport",
    "colorpatterns": "Color patterns",
    "musicwhichone": "Which instrument?",
    "bodytangram": "Body tangram",
    "musicsimon": "Musical sequence",
    "colorsmix": "Color mixing",
    "foodslider": "Discovering food",
    "clothes": "Discovering clothes",
    "seasons": "Seasons",
    "coloringpixels": "Color by numbers",
    "shapesclassify": "Shape classification",
    "numberswhohasmore": "The gluttons",
    "positioningdiscovery": "Where is Jane?",
    "songheadandshoulders": "Colors",
    "letterscookies": "Letter cookies",
    "lettersshopping": "The letter shop",
    "bodyslider": "Discovering the body",
    "identifyactionemotions": "Action and emotion",
    "whathappensnext": "What happens next?",
    "setthealarmclock": "Clock hands",
    "animalscoloring": "Color animals",
    "characterscoloring": "Color Kokoros",
    "rhymesshop": "The rhyme shop",
    "numberseatsubtractions": "I eat one",
    "numbersbuildawallinblocks": "The addition wall",
    "numberslosingitems": "The subtraction backpack",
    "numbersgrabthefruit": "Fruit basket",
    "environmentfishingrubbish": "Clean the sea",
    "colorsorchard": "The orchard",
    "spotdifferences": "The differences",
    "charactershideandseek": "Where are the Kokoros?",
    "characterscostumes": "Dress up",
    "carjam": "The parking lot",
    "treasuremap": "Treasure map",
    "findindarkroom": "The flashlight",
    "weatherwhichone": "Which weather?",
    "rightleftdelivery": "Up and down bus",
    "flysolarsystem": "The solar system",
    "flycontinents": "The continents",
    "flyoceans": "The oceans",
    "animalsheneggs": "The egg and the hen",
    "animalssoundswhichone": "Listen to the animal",
    "numberswheelfortune": "The Ferris wheel",
    "numbersmoneyclassify": "The piggy banks",
    "numbershowmanyinbarn": "How many fit?",
    "numbersalgebroid": "Math brick breaker",
    "coloroid": "Color brick breaker",
    "rightleftdeliverycolors": "Color delivery",
    "numberspotions": "Number potion",
    "foodcook": "Cook the food",
    "bodyshower": "Wash your body",
    "bodyfacewash": "Wash your face",
    "christmasmusichero": "Christmas piano",
    "racingcolors": "Colors",
    "christmasdecoratetree": "Decorate the tree",
    "pillchest": "Colors",
    "christmascoloring": "Color Christmas",
    "christmasmemory": "Christmas memory",
    "covidgame": "Colors",
    "ramonelcamaleon": "Ramon the Chameleon",
    "discoverycolors": "Discover colors",
    "memory": "Memorize",
    "miceandcoding": "Guide the mouse",
    "drawthepath": "Draw the path",
    "tangram": "Lego tangram",
    "zamburguesas": "Zamburgers",
    "pizzafor2": "Pizza for two",
    "hideandseek": "Hide and seek",
    "whichage": "What is their age?",
    "letterjigsawsliderjobs": "Jobs jigsaw",
    "whichemotion": "Which emotion?",
    "letterjigsawsliderdinos": "Dinosaur jigsaw",
    "monsterparts": "Count the monsters",
    "thesenses": "The senses",
    "aboutschool": "About school",
    "halloweenbingo": "Halloween bingo",
    "letterjigsawsliderfood": "Food jigsaw",
    "letterjigsawsliderinsects": "Insect jigsaw",
    "lettersjigsawslidervehicles": "Vehicle jigsaw",
    "lettersjigsawslidermarineanimals": "Marine jigsaw",
    "christmasbingo": "Christmas bingo",
    "lettersjigsawchristmas": "Christmas jigsaw",
    "wedraw": "We draw",
    "whereisthis": "Where are they?",
    "emotionsinarow": "Emotions in a row",
    "lettersmessvowels": "Vowel mess",
    "coloringpixelvowels": "Color with vowels",
    "wordworm": "Word worm",
    "lettersskymap": "Letter star map",
    "letterssorthome": "Sort the letters: At home",
    "letterssortanimals": "Sort the letters: Animals",
    "letterssortcity": "Sort the letters: In the city",
    "insectsbingo": "Insect bingo",
    "emotionsbingo": "Emotions bingo",
    "wordsearchanimals": "Word search: Animals",
    "marinebingo": "Marine animals bingo",
    "jobsbingo": "Jobs bingo",
    "lettersmissinghome": "Complete the words: Home",
    "easterbingo": "Easter bingo",
    "springbingo": "Spring bingo",
    "lettersjigsawsliderspring": "Spring jigsaw",
    "lettersmissinginsects": "Complete the words: Insects",
    "lettersmissingfood": "Complete the words: Food",
    "lettersmissingsports": "Complete the words: Sports",
    "cutwords": "Cut words",
    "quijotebingo": "Quixote bingo",
    "theabc": "The ABC",
    "realfooder": "Real food",
    "organizesentence": "Organize the sentence",
    "emotionmatch": "Match the emotion",
    "fairytales": "Fairy tales",
    "animalshadow": "Animal shadows",
    "coloringpixelconsonantsone": "Color pixels with consonants",
    "wordsearchfood": "Word search: Food",
    "wordsearchjobs": "Word search: Jobs",
    "tapthefish": "Catch the fish",
    "howmany": "How many are there?",
    "guesswho": "Guess who?",
    "pooptime": "Poop time",
    "unboxing": "Tidy up the house",
    "emotionssudoku": "Emotions sudoku",
    "talktowin": "Talk and win the race",
    "wordsearchsummer": "Word search: Summer",
    "summerinarow": "Summer in a row",
    "sportsinarow": "Sports in a row",
    "organizethesentence": "Organize the sentence",
    "wedrawhalloween": "We draw Halloween",
    "additionsmess": "Addition mess",
    "numbersmess": "Number mess",
    "techinarow": "Technology in a row",
    "veggiesinarow": "Veggies in a row",
    "kokorocreator": "Kokoro creator",
    "drawthepathwinter": "Draw the winter path",
    "rainbowbeehive": "Rainbow beehive",
    "imitateemotions": "Imitate the emotion: Beginner",
    "imitateemotionsmedium": "Imitate the emotion: Intermediate",
    "imitateemotionshard": "Imitate the emotion: Expert",
    "findtheoddemotion": "Spot the differences: emotions",
    "numberscomp": "Greater or less",
    "treasurehunt": "Treasure hunt in the forest",
    "intrudersearch": "Find the intruder",
    "shapesoflife": "The shape of things",
    "clothingfitsyou": "Where do I wear it?",
    "thatistheduck": "That's the duck!",
    "eddiecolors": "Eddie and the Colors",
    "thebigchain": "The Big Chain",
    "mesozoicera": "Mesozoic Era",
    "wedrawempathy": "We draw empathy",
    "candychameleon": "Candy Chameleon",
    "vintagetech": "Vintage Technology",
    "discoverrobots": "Discovering robots",
    "icecreamfor2": "Ice cream for two",
    "whereisthisdog": "Where is the dog?",
    "whereisthiscat": "Where is the cat?",
    "masterofsyllables": "Master of syllables",
    "drawyourpuzzleschool": "Draw your puzzle: School",
    "goodhabits": "Good habits",
    "findindarkroomstrangethings": "Find the strange thing",
    "wordchain": "Word chain",
    "marinelifecount": "Marine life count",
    "winter_fairytales": "Winter Fairytales",
    "organizerubbish": "Recycling",
    "whichjob": "Who's who? Professions"
  },
  "games_desc": {
    "colors": "Press the arrows to discover colors and their names",
    "shapesemptyboard": "Make the geometric shapes on the board disappear",
    "shapes": "Press the arrows to discover geometric shapes and their names",
    "shapescoloring": "Color the geometric shapes in these drawings however you like",
    "shapesdrag": "Drag the geometric shapes to their silhouettes",
    "shapesjigsaw": "Join the puzzle pieces to see the complete images",
    "shapesmemory": "Colors",
    "shapeswhichone": "Choose the geometric figure you're asked for",
    "shapestrace": "Trace the shape of geometric figures to learn to draw them",
    "shapesfalling": "Tap the falling geometric figures as appropriate",
    "colorscandy": "Sort the candies and put them in their dispensers by color",
    "colorsmemory": "Colors",
    "balloonsempty": "Pop the balloons by color until the screen is empty",
    "balloonspop": "Tap and pop the floating balloons by color",
    "shapeshalf": "Place the cut pieces on their other half to form complete shapes",
    "shapessmallorbig": "Choose the shape based on whether it's big or small",
    "shapessmalltobig": "Sort the shapes by size by dragging them",
    "numbers": "Press the arrows to discover numbers 1 to 6",
    "numbersdrag": "Drag the number to its matching silhouette",
    "numberscounting": "Learn to add by tapping the ducklings",
    "numbershowmany": "Tap the number that matches how many animals you see",
    "numbersfalling": "Tap the floating bubbles with the correct numbers",
    "numbersmemory": "Colors",
    "numberssort": "Drag the boxes to the monkeys of different sizes depending on whether their number is greater or smaller",
    "numberswhichone": "Which number are they asking for? Can you identify it?",
    "shapestangram": "Identify simple geometric figures and place them in the correct spot",
    "numbersrunning": "Each rabbit has a number. Can you place each one in the right wagon?",
    "numbersbingo": "Count the animals that appear and tap the numbers to form lines on the board",
    "numbersfindthepath": "Tap the numbers in order to trace the path home",
    "numbersbalance": "Balance the scale to help Alan reach the treasure",
    "numberspizza": "Place the exact number of ingredients Alan needs on the pizza",
    "numbersadd": "Learn to calculate simple additions with Alan's magic",
    "numberssubtract": "Learn to calculate simple subtractions with Alan's magic",
    "animalsmemory": "Colors",
    "animalswhichone": "Choose the correct animal you're asked for",
    "animals": "Press the arrows to discover animals' names and appearances",
    "animalssounds": "Select a habitat to hear the sounds of the animals that live there",
    "animalsmixthem": "Arrange these images until you see a complete animal drawing",
    "animalsbingo": "Recognize and select the animals you're asked for to create lines",
    "animalsdragtoplace": "Drag the animals into their correct habitat to their silhouettes",
    "animalsfood": "Drag the food to the animals, but give them only what they usually eat",
    "animalsrunning": "Drag the animals onto the boat so they can travel with Nikola",
    "animalsconnect": "Connect the dots in order to create a drawing",
    "animalsjigsaw": "Drag the pieces to the correct place to complete the image",
    "numberstrace": "Choose a number and follow its trace to learn to write it.",
    "animalsmatchfood": "Match the animal with the food it eats",
    "lettersmatchupperlower": "Match uppercase letters with their lowercase letters",
    "letters": "Press the arrows to discover letter names and their shapes",
    "lettersmissing": "Drag the missing letter to complete the animals' names",
    "letterssort": "Sort the letters to form the names of foods",
    "lettersjigsawslider": "Place the pieces correctly to discover everyday objects and their names",
    "letterstraceupper": "Choose an uppercase letter and follow its trace to learn to write it",
    "letterstracelower": "Choose a lowercase letter and follow its trace to learn to write it",
    "letterschoosecorrect": "Choose the correct word that matches the image",
    "lettersmemory": "Choose the correct word that matches the image",
    "lettersmatchimage": "Match the objects with the first letter of their name",
    "lettersbingo": "Select the letter that the object starts with to create lines",
    "lettersdrag": "Drag uppercase letters into the matching shapes to learn to recognize them",
    "lettersupperfindthepath": "Follow the dotted path by tapping adjacent letters to get home",
    "musicalinstruments": "Press the arrows to discover musical instruments",
    "musicplayinstruments": "Choose any instrument to play freely and practice your musical creativity",
    "animalsbrowse": "Tap the animals to learn their names and appearance",
    "musichero": "Play the notes shown on the keyboard to make the song sound.",
    "musicnotesfalling": "Tap the falling notes to play the song",
    "letterscollectstuff": "Find the everyday objects you're asked for in these rooms",
    "numberssnake": "Drag the worm to the numbers to create the sequence and make the worm grow and turn into a butterfly",
    "numbersdressbigsmall": "Learn to tell big from small by dressing the bear and the monkey",
    "numberssupermarket": "Learn to make a shopping list and shop at the supermarket. Remember the steps to follow!",
    "animalssoundsgrid": "Learn animal sounds by tapping each one",
    "castlepatterns": "Follow shape and color patterns to help Alan cross the bridge",
    "numbersaddscales": "Balance the scale by dragging the result of the sum",
    "bodydiscovery": "Tap the characters to discover the names of body parts",
    "numbersspaceship": "Choose the number that should go in the sequence so Alan can discover the spaceship code",
    "transport": "Press the arrows to discover types of vehicles and their appearance",
    "colorpatterns": "Choose the suitcase color that follows the conveyor belt pattern",
    "musicwhichone": "Listen to the instruments and choose the one that played",
    "bodytangram": "Place the body parts of these drawings in the correct position",
    "musicsimon": "Memorize the musical sequence Wolfie is playing and then play it",
    "colorsmix": "Mix the colors correctly so the drawing gets colored",
    "foodslider": "Press the arrows to discover types of foods and their appearance",
    "clothes": "Press the arrows to discover types of clothing and their appearance",
    "seasons": "Discover the seasons and their weather",
    "coloringpixels": "Identify the colors of the drawings' pixels by their number",
    "shapesclassify": "Move the objects to the correct basket according to their shape",
    "numberswhohasmore": "Tap the animal you think has more or less food",
    "positioningdiscovery": "Learn prepositions by finding Jane's position",
    "songheadandshoulders": "Colors",
    "letterscookies": "Bake these cookies with the letter shapes you prefer and decorate them",
    "lettersshopping": "Jane can only buy objects that start with certain letters. Can you identify them?",
    "bodyslider": "Tap the arrows to discover and learn the names of body parts and what they are like",
    "identifyactionemotions": "The curtain opens. What are the Kokoros feeling or doing?",
    "whathappensnext": "Choose the image with the next action Jane will do",
    "setthealarmclock": "Move the clock hands and set the correct time so Alan isn't late for his activities",
    "animalscoloring": "Paint these animals however you like",
    "characterscoloring": "Paint the Kokoros however you like",
    "rhymesshop": "Choose the objects that rhyme with others in this varied shop",
    "numberseatsubtractions": "Do the subtraction and find out how many foods are left on the table after Alan has had his snack",
    "numbersbuildawallinblocks": "Build walls with the number of bricks needed. Watch the groups so you don't use too many bricks!",
    "numberslosingitems": "Oh no! Alan has a hole in his backpack. How many fruits did he lose?",
    "numbersgrabthefruit": "Distribute the number of fruits each basket needs",
    "environmentfishingrubbish": "Help Nikola clean the seas of trash by picking what doesn't belong",
    "colorsorchard": "Collect the vegetables by the color that appears when you roll the die",
    "spotdifferences": "Can you find the differences between the two images?",
    "charactershideandseek": "Train attention by finding the Kokoros in the scene. They're well hidden!",
    "characterscostumes": "Help the Kokoros choose the costumes you like most and learn to dress them",
    "carjam": "Slide the cars so Nikola can leave the parking lot",
    "treasuremap": "Place the pieces to make the correct path to the treasure",
    "findindarkroom": "Use the flashlight to find the hidden objects you're asked for in these everyday places",
    "weatherwhichone": "Learn to say what the weather is like outside",
    "rightleftdelivery": "Guide the bus to pick up the Kokoros at stops, identifying up and down",
    "flysolarsystem": "Help Nikola travel from one planet to another, learn their names, and memorize them",
    "flycontinents": "Help Nikola travel from one continent to another, learn their names, and memorize them",
    "flyoceans": "Help Nikola travel from one ocean to another, learn their names, and memorize them",
    "animalsheneggs": "Which came first, the egg or the hen? Discover the life cycle on this farm",
    "animalssoundswhichone": "Identify the animal sounds and tap the one that made it",
    "numberswheelfortune": "A gondola is missing on the Ferris wheel. Can you say what number it is?",
    "numbersmoneyclassify": "Put each coin in the piggy bank that shows its value",
    "numbershowmanyinbarn": "Count the animals entering the barn",
    "numbersalgebroid": "Guide the ball result to the blocks with its operation until none remain",
    "coloroid": "Guide the ball to the blocks of the corresponding color until none remain",
    "rightleftdeliverycolors": "Move the boat next to the correct color",
    "numberspotions": "Place the objects in the cauldron to create a magic potion",
    "foodcook": "Drag the foods to the grill to cook them, learn their names, and give Jane her snack",
    "bodyshower": "Help Alan learn to wash his body step by step",
    "bodyfacewash": "Help Alan learn to wash his face step by step",
    "christmasmusichero": "Follow the piano steps to learn to play these Christmas songs",
    "racingcolors": "Colors",
    "christmasdecoratetree": "Decorate the Christmas tree to your liking",
    "pillchest": "Colors",
    "christmascoloring": "Paint these Christmas drawings however you like.",
    "christmasmemory": "Flip the Christmas cards and memorize their positions to make pairs",
    "covidgame": "Colors",
    "ramonelcamaleon": "Help in this story Ramon the Chameleon who changes color with each emotion",
    "discoverycolors": "Flip the cards to learn to identify colors and their names",
    "memory": "Flip the cards to learn to identify colors and their names",
    "miceandcoding": "Plan the route the mouse must take to reach the cheese. Watch out for the cat!",
    "drawthepath": "Draw a line that helps the ball reach Wolfie",
    "tangram": "Fit the Lego pieces on the board until it's complete",
    "zamburguesas": "With a friend, work together so each character reaches the boat",
    "pizzafor2": "Cooperate with a partner to make as many pizzas as possible before time runs out",
    "hideandseek": "In pairs, play to hide the mobile device in real life, following the instructions",
    "whichage": "Can you tell who is older? And who is younger?",
    "letterjigsawsliderjobs": "Place the pieces correctly to discover the professions and their names",
    "whichemotion": "Tap the emotion that matches the image",
    "letterjigsawsliderdinos": "Place the pieces correctly to discover the dinosaurs and their names",
    "monsterparts": "Count the monster parts and tap the correct answer",
    "thesenses": "Learn the senses and how we use them",
    "aboutschool": "Tap the correct school items to learn their names",
    "halloweenbingo": "Choose the Halloween decoration you're asked for to make lines",
    "letterjigsawsliderfood": "Place the pieces correctly to discover foods and their names",
    "letterjigsawsliderinsects": "Place the pieces correctly to discover insects and their names",
    "lettersjigsawslidervehicles": "Place the pieces correctly to discover vehicles and their names",
    "lettersjigsawslidermarineanimals": "Place the pieces correctly to discover marine animals and their names",
    "christmasbingo": "Tap the Christmas objects you're asked for to make lines",
    "lettersjigsawchristmas": "Place the pieces correctly to discover Christmas objects and their names",
    "lettersmessvowels": "Drag on the screen to find and identify the floating lowercase and uppercase vowels",
    "emotionsinarow": "Recognize emotions and place them in the correct spot to complete lines",
    "wedraw": "Draw freely the assigned theme and then see how others drew the same theme",
    "whereisthis": "Search and find objects and characters in the crowd",
    "coloringpixelvowels": "Color the pixel drawings with the color indicated by the vowels",
    "wordworm": "Make the little worm eat the letters to learn the alphabet and form words",
    "letterssorthome": "Sort the letters to form words we can find at home",
    "letterssortanimals": "Sort the letters to form animal names",
    "letterssortcity": "Sort the letters to form the names of items you can find in the city",
    "insectsbingo": "Select the insects you're asked for to make lines",
    "emotionsbingo": "Select the emotions you're asked for to make lines",
    "marinebingo": "Select the marine animals you're asked for to make lines",
    "jobsbingo": "Select the professions you're asked for to make lines",
    "lettersmissinghome": "Drag the missing letter to complete the home-themed word",
    "easterbingo": "Select the Easter items you're asked for to make lines",
    "springbingo": "Select the spring items you're asked for to make lines",
    "lettersjigsawsliderspring": "Place the pieces correctly to discover spring objects",
    "lettersmissinginsects": "Drag the missing letter to complete insect names",
    "lettersmissingfood": "Drag the missing letter to complete food names",
    "lettersmissingsports": "Drag the missing letter to complete sports names",
    "cutwords": "Separate the words by cutting the paper to form sentences",
    "quijotebingo": "Select the reading-related items you're asked for to make lines",
    "theabc": "Learn the alphabet by tapping the correct answer",
    "realfooder": "Match the food photograph with its drawing",
    "howmany": "Match number to quantity from 1 to 5",
    "guesswho": "Tap the correct character based on their traits",
    "emotionmatch": "Identify the emotion in a real image and its drawing representation",
    "fairytales": "Quiz about children's tales",
    "animalshadow": "Select the animal's shadow with the matching animal",
    "wordsearchanimals": "Find in this word search the animal names hidden in the grid",
    "lettersskymap": "Trace and discover the alphabet letters. Move the device or drag on the screen to find the constellations",
    "tapthefish": "The bubbles show where the fish will appear. Catch it! Then count how many you got.",
    "wordsearchjobs": "Find in this word search the job vocabulary hidden in the grid.",
    "pooptime": "The Kokoros are pooping! Help them with their routine before time runs out.",
    "unboxing": "Place the objects where they belong in the different rooms of the house",
    "emotionssudoku": "Place the emotions without repeating them in the same row, column, or box.",
    "talktowin": "Use your voice to cheer the character on and make them run faster.",
    "wordsearchsummer": "Find in this word search the summer vocabulary hidden in the grid.",
    "summerinarow": "Recognize summer items and place them in the correct spot to complete lines.",
    "sportsinarow": "Recognize sports items and place them in the correct spot to complete lines.",
    "wordsearchfood": "Find in this word search the food names hidden in the grid.",
    "organizethesentence": "Arrange the words to form meaningful sentences.",
    "coloringpixelconsonantsone": "Color the pixel drawings with the color indicated by consonants.",
    "wedrawhalloween": "Draw the other half of the Halloween element and see what others created",
    "additionsmess": "Drag the screen to find and add the floating numbers until you reach the indicated result",
    "numbersmess": "Drag the screen to find and identify the floating numbers",
    "techinarow": "Recognize tech objects and place them in the correct spot to complete lines",
    "veggiesinarow": "Recognize vegetable foods and place them in the correct spot to complete lines",
    "kokorocreator": "Create your own character with specific traits and creativity",
    "drawthepathwinter": "Help the snowman recover his head. Draw a line to support his movement.",
    "rainbowbeehive": "Relax by changing the color of the hive and learn how important bees are.",
    "imitateemotions": "Move the parts of the face to recreate the correct emotion.",
    "imitateemotionsmedium": "Move more parts of the face to recreate the correct emotion. At this intermediate level you'll have more elements to modify and expressions made by different characters.",
    "imitateemotionshard": "Expert emotional level. Now move the parts of the face to recreate the correct emotion from the real reference image",
    "wedrawempathy": "Draw about your friends, family, and the things you like most and share your creations with other children. You'll learn about other ways of seeing the world.",
    "icecreamfor2": "Cooperate with someone to make as many ice creams as possible before time runs out",
    "whereisthisdog": "Search and find these puppies in the crowd",
    "whereisthiscat": "Search and find these kittens in the crowd",
    "candychamaleon": "Help Caramelo the chameleon control his impulses and his breathing.",
    "drawyourpuzzleschool": "Draw with colors and stickers. When you finish your drawing, it will turn into a puzzle to solve.",
    "eddiecolors": "Learn with Eddie to differentiate colors, from the easiest to the most complex.\n",
    "winter_fairytales": "How much do you know about winter stories? Learn interesting facts about stories.",
    "findindarkroomstrangethings": "Use the flashlight to search for the strange things from the 80s that are indicated to you.",
    "marinelifecount": "Count the legs, spots, and details of marine animals as you explore and learn about the fauna of the deep sea.",
    "goodhabits": "Learn vocabulary related to hygiene and personal care habits.",
    "wordchain": "Follow the chain of words. Choose the word that begins with the last syllable of the previous word and complete the chain.",
    "masterofsyllables": "Identify how many syllables each word has to improve reading, writing, and pronunciation.",
    "thatistheduck": "Look closely at the ducks and find the one that matches the given characteristic. It could be a color, an accessory, or a specific costume. Pay attention to the details and choose the right duck!",
    "vintagetech": "How did people use to make phone calls? How did they write messages to each other from afar? Learn about old technology.",
    "thebigchain": "Learn about food chains, and which organisms are producers, consumers, and decomposers in nature.",
    "discoverrobots": "Learn what robots are and which ones you might encounter in your daily life.",
    "findtheoddemotion": "Your mission is to find the emotion that is NOT the same as the others. Can you find them all?",
    "organizerubbish": "Sort the product into the appropriate recycling bin",
    "mesozoicera": "Learn about dinosaurs and identify what did and did not coexist with them.",
    "clothingfitsyou": "Correctly identify each item of clothing on the parts of the body and develop body awareness.",
    "shapesoflife": "Observe everyday objects and identify their geometric shapes.",
    "intrudersearch": "Players must find which of the objects does not match the others.",
    "treasurehunt": "Identify all insects, trees, and flowers.",
    "numberscomp": "Find out which numbers are greater or less.",
    "whichjob": "Guess the profession"
  },
  "categories": {
    "emotions": "Socio-emotional",
    "brain_games": "Cognitive skills",
    "numbers": "Logical-mathematical",
    "communication": "Linguistic competence",
    "creativity": "Creativity",
    "science_nature": "Science"
  },
  "subcategories": {
    "literacy": "Literacy",
    "vocabulary": "Vocabulary",
    "grammar": "Grammar",
    "communication": "Communication",
    "attention": "Attention",
    "executive_functions": "Executive functions",
    "preception": "Perception",
    "orientation": "Orientation",
    "problem_solving": "Problem solving",
    "emotional_awareness": "Emotional awareness",
    "personal_autonomy": "Self-reliance",
    "social_competence": "Social competence",
    "emotional_regulation": "Emotional regulation",
    "number_sense": "Number sense",
    "operations": "Operations",
    "measures": "Measurement",
    "geometry": "Geometry",
    "logic": "Logic",
    "environment": "Environment",
    "fauna": "Wildlife",
    "human_being": "Human being",
    "food": "Food",
    "natural_events": "Natural events",
    "universe": "Universe",
    "living_in_society": "Social Science",
    "technology": "Technology",
    "history": "History",
    "visual_arts": "Visual arts",
    "music": "Music",
    "perception": "Perception"
  },
  "objectives": {
    "history": "History",
    "fears": "Fears",
    "language": "Language",
    "letter_discrimination": "Letter recognition",
    "spelling": "Spelling",
    "graphomotricity": "Graphomotor skills",
    "compose_words": "Building words",
    "reading": "Reading",
    "animals": "Animals",
    "food": "Nutrition",
    "colors": "Colors",
    "sports": "Sports",
    "technology": "Technology",
    "hobbies": "Hobbies",
    "transport_means": "Means of transport",
    "immediate_surroundings": "Immediate environment",
    "body_parts": "Body parts",
    "professions": "Professions",
    "clothing": "Clothing",
    "festivities": "Holidays",
    "semantic_association": "Semantic association",
    "sentences_forming": "Sentence structure",
    "grammar_knowledge": "Grammar skills",
    "orthography": "Spelling",
    "oral_expression": "Speaking skills",
    "oral_compression": "Listening comprehension",
    "phonological_knowledge": "Phonological awareness",
    "sustained_attention": "Sustained attention",
    "focused_attention": "Focused attention",
    "divided_attention": "Divided attention",
    "alternating_attention": "Alternating attention",
    "selective_attention": "Selective attention",
    "work_memory": "Working memory",
    "cognitive_flexibility": "Cognitive flexibility",
    "anticipation": "Anticipation",
    "reasoning": "Reasoning",
    "response_sepped": "Processing speed",
    "planning": "Planning",
    "inhibitory_control": "Inhibitory control",
    "visual_perception": "Visual perception",
    "auditory_perception": "Auditory perception",
    "visual_discrimination": "Visual discrimination",
    "spatial_orientation": "Spatial orientation",
    "personal_orientation": "Self-orientation",
    "temporary_orientation": "Temporal orientation",
    "compare": "Comparison",
    "association": "Pattern recognition",
    "classification": "Classification",
    "emotions_recognition": "Emotion recognition",
    "self_knowledge": "Self-knowledge",
    "emotions_expression": "Emotional expression",
    "self_confident": "Self-esteem",
    "life_skills": "Life skills",
    "routines": "Routines",
    "financial_independence": "Financial independence",
    "security": "Safety",
    "motor_skills_development": "Motor skills development",
    "social_standards": "Social norms",
    "civic_values": "Civic values",
    "social_skills": "Social skills",
    "cultural_diversity": "Cultural diversity",
    "conflicts_solving": "Conflict resolution",
    "cooperation": "Cooperation",
    "mind_theory": "Theory of mind",
    "frustration_tolerance": "Frustration tolerance",
    "behaviour_regulation": "Self-regulation",
    "relax": "Coping skills",
    "impulsivity_work": "Impulse control",
    "fear_management": "Fear management",
    "numerical_representation": "Numerical representation",
    "counting": "Counting",
    "numerical_correlation": "One-to-one correspondence",
    "portions": "Fractions",
    "sums": "Addition",
    "substracts": "Subtraction",
    "multiplications": "Multiplication",
    "divisions": "Division",
    "size": "Size",
    "length": "Length",
    "weight": "Weight",
    "time": "Time",
    "money": "Money",
    "geometric_shapes": "Geometric shapes",
    "symmetries": "Symmetry",
    "straight_lines_types": "Types of lines",
    "sequence": "Sequences",
    "patterns": "Patterns",
    "serialisation": "Seriation",
    "computational_thinking": "Computational thinking",
    "recycling": "Recycling",
    "landscape": "Landscape",
    "vegetation": "Plants",
    "animal_kingdom": "Animal kingdom",
    "life_functions": "Life functions",
    "habitat": "Habitat",
    "dinasours": "Dinosaurs",
    "human_body": "Human body",
    "physical_characteristics": "Body features",
    "senses": "Senses",
    "food_types": "Food types",
    "healthy_food": "Healthy food",
    "weather": "Weather",
    "year_season": "Seasons of the year",
    "planets": "Planets",
    "spacial_bodies": "Space bodies",
    "earth": "Earth",
    "moon": "Moon",
    "home": "Home",
    "school": "School",
    "traditions": "Traditions",
    "experiments": "Experiments",
    "machines": "Machines",
    "programming": "Programming",
    "robotics": "Robotics",
    "civilizations": "Civilizations",
    "historical_characters": "Historical characters",
    "technique": "Technique",
    "drawing": "Drawing",
    "use_of_materials": "Use of materials",
    "creativity_expression": "Creative expression",
    "colors_discrimination": "Color discrimination",
    "decoration": "Decoration",
    "rhythm": "Rhythm",
    "melody": "Melody",
    "music_styles": "Music styles",
    "instruments": "Instruments",
    "year_seasons": "Seasons of the year",
    "response_speed": "Response speed",
    "dinosaurs": "Dinosaurs",
    "subtracts": "Subtraction",
    "decision_making": "Decision making",
    "categorization": "Categorization",
    "selectedCount": "{count} selected"
  },
  "faqs_categories": {
    "first_steps": "Account",
    "account": "User profile",
    "creating_customized_sessions": "Creating customized sessions",
    "content_and_games": "Content and games",
    "plans": "Plans",
    "accessibility_and_inclusion": "Accessibility and inclusion",
    "resources_and_training": "Resources and training",
    "technical_support": "Technical support"
  },
  "faqs_subcategories": {
    "first_question": "I'm already a Kids user, do I need to register again?",
    "first_text": "",
    "second_question": "Can I use Kokoro Schools if I don't work at a school?",
    "second_text": "Yes! Although Kokoro Schools is designed mainly for school settings, it is also useful outside schools. If you work in an alternative educational context, such as home support, educational therapies, tutoring centers, or even as a parent or guardian who wants to improve a child's development, Kokoro Schools can help you in several ways, discover it in this <a href='https://link.apolokids.com/DNG3Fv' target='_blank'>post on our blog</a>\n",
    "third_question": "I'm a psychologist, how does Kokoro Schools help me in my daily work?",
    "third_text": "As a psychologist, Kokoro Schools offers you the possibility of integrating play into therapy to work on various areas of children's emotional and cognitive development. Some practical uses in therapy include assessment and follow-up, personalization of therapeutic activities or emotion regulation. In this <a href='https://link.apolokids.com/dAOVvz' target='_blank'>post</a> we explain how to introduce Kokoro Schools in therapy and the benefits of play.",
    "fourth_question": "I'm a teacher, how does Kokoro Schools benefit me in the classroom?",
    "fourth_text": "As a teacher, Kokoro Schools not only helps you manage individualized and personalized learning, but it can also be combined with other innovative and traditional methodologies in the classroom to further enhance teaching. <a href='https://link.apolokids.com/5dx7q9' target='_blank'>Here we explain how</a>",
    "fifth_question": "Is Kokoro Schools useful if I'm not a psychologist or teacher?",
    "fifth_text": "Yes, Kokoro Schools can be a valuable tool even if you are not a psychologist or teacher. Designed to support learning and child development, the platform is useful for parents, guardians, activity monitors, researchers and educational technology professionals. Thanks to its personalization options and its focus on attention to diversity, it allows content to be adapted to different needs and contexts. <a href='https://apolokids.com/kokoro-schools-para-psicologos-como-integrarlo-en-terapia/' target='_blank'>Discover how to use Kokoro Schools in this article.</a>",
    "sixth_question": "Which child profiles is it recommended for?",
    "sixth_text": "Kokoro Schools is recommended for all children, since it adapts to different rhythms and learning levels, making it ideal both for neurotypical children and for those with specific educational support needs (NEAE). The platform is inclusive, adjusting to each child's individual needs, promoting personalized learning respectful of their development process.</br>\nIt is especially useful for children with ADHD and ASD, as it offers options to regulate visual and auditory stimuli, avoiding sensory overload. Adaptive games allow children to progress at their own pace, fostering a more positive learning environment without pressure.</br>\nThe focus on key areas such as socio-emotional development, creativity, linguistic competence and logical-mathematical skills makes it suitable for children at various educational stages, from early childhood education to primary school, contributing to the comprehensive development of essential skills.</br>",
    "seventh_question": "How can I request a demo for my school?",
    "seventh_text": "To request a demo of Kokoro Schools for your educational center, you can write to our contact email. One of our advisors will give you a demo and answer all your questions about how to make the most of the platform at your center.",
    "eighth_question": "Are there schools already using Kokoro Schools?",
    "eighth_text": "Yes, we currently have educational centers in different parts of the world such as Spain, Peru or Abu Dhabi using Kokoro Schools to improve their students' learning experience. </br>\n\nThese centers are implementing Kokoro Schools to personalize learning, improve socio-emotional skills and support students with special educational needs.</br>",
    "ninth_question": "I have a problem, how can I contact you?",
    "ninth_text": "",
    "tenth_question": "What benefits does Kokoro Schools offer to children?",
    "tenth_text": "Kokoro Schools offers multiple benefits for children, focusing on their <b>holistic development through personalization and adaptive play</b>. By allowing professionals to create experiences tailored to individual needs, children can progress at their own pace and receive specific support in areas that need more reinforcement, such as logical-mathematical skills, linguistic competence, or socio-emotional development. This learning adaptation is especially beneficial for those with <b>specific educational support needs (NEAE)</b>, such as learning difficulties, specific language disorders or dyslexia, since the platform adjusts to improve comprehension and retention of key concepts.</br>\n\nThe play-based approach also boosts socio-emotional well-being, providing children with a space where they feel safe to explore and express themselves. <b>Cooperative and social learning games</b> help foster empathy, communication and teamwork, essential skills for emotional development. In addition, the possibility of <b>regulating stimuli and limiting time</b> of use guarantees a safe environment, allowing children to focus and avoid overstimulation.</br>\n\nWith the inclusion of a wide variety of content and activities, Kokoro Schools seeks not only to support academic learning, but also to strengthen autonomy, self-esteem and creativity in children, preparing them in a balanced way for future challenges.</br>",
    "eleventh_question": "How many children or profiles can I create?",
    "eleventh_text": "It depends on the type of plan you have active. If you are using our free version and no longer enjoy the trial period, you can only create/use one student profile.</br> <br>However, if you have the professional subscription you can create and use up to 3 profiles. With our most complete plan, the school plan, the number of profiles is unlimited.</br>",
    "twelfth_question": "What languages can they play in?",
    "twelfth_text": "They can play in four different languages: Spanish (Spain), English (USA), Portuguese (Brazil) and Bahasa (Indonesia) (more languages coming soon)</br>\n\nUsing our activities in a language different from the student's native language is a different way to use our resources, as it can introduce them to learning the chosen language.</br>",
    "thirteenth_question": "What development areas can I work on with children?",
    "thirteenth_text": "You will be able to work on multiple key areas for children's development, focusing on their academic, cognitive and socio-emotional growth. The platform allows you to reinforce logical-mathematical skills through games that develop problem solving and critical thinking, as well as work on linguistic competence through activities that improve vocabulary, oral expression and reading comprehension.</br>\n\nIt also boosts socio-emotional development, providing a safe space to learn to recognize and manage emotions, strengthen self-esteem and work on empathy and collaboration through cooperative games. Cognitive skills, such as memory, attention and visual processing, are also areas of focus, ensuring that each child advances at their own pace and abilities.</br>\n\nIn addition, Kokoro Schools includes content and activities that stimulate creativity and scientific curiosity, helping children explore science and technology concepts in a dynamic way. All of this is done in an inclusive and safe environment, adapted to individual needs, which facilitates a complete and personalized learning experience.</br>",
    "fourteenth_question": "Which devices can I use Kokoro Schools on?",
    "fourteenth_text": "Kokoro Schools can be used from any device and any operating system, and it does not require installation because it is an interactive web. \nYou can create your educational sessions wherever you are!</br>\n\nHowever, for your students to access the activities in your educational sessions, they will need a mobile device (smartphone or tablet) with the Kokoro Kids app installed and signed in with your account, so they can also access the sessions you prepared, wherever they are.</br>\n\nThe Kokoro Kids app can be downloaded from the App Store or Google Play.</br>",
    "fifteenth_question": "I'd like to suggest an improvement, how can I contact you?",
    "fifteenth_text": "You can send us a message to our email and our pedagogy team will get back to you.",
    "sixteenth_question": "Can Kokoro Schools create personalized sessions for my students?",
    "sixteenth_text": "",
    "seventeenth_question": "Is it adapted? or what is the degree of adaptation?",
    "seventeenth_text": "Yes, Kokoro games are designed to adapt to each child's level as they progress. We use a <b>progressive leveling system</b> that adjusts difficulty according to the player's performance, allowing learning at their own pace. In addition, each game works different skills with varied approaches, offering suitable challenges without generating frustration. This adaptation guarantees that all children, regardless of their starting point, can enjoy and benefit from learning through play.",
    "eighteenth_question": "What ages is it recommended for?",
    "eighteenth_text": "It is recommended for children <b>over 3 years old</b>, since it covers from <b>early childhood education to primary education.</b> The games are designed to adapt to the different stages of cognitive, emotional and social development of children in this age range.</br>\nThe platform adapts both to younger children, who are in the early stages of development, and to older children, since game levels adjust to each child's pace and level. This makes it effective both for children who are just beginning to develop basic skills, such as language and logic, and for those who are advancing in more complex areas, such as math or science.</br>\nIn addition, it is particularly useful for children with <b>specific educational support needs (NEAE)</b>, as it offers inclusive features such as stimulus regulation and personalized activities based on individual needs</br>",
    "nineteenth_question": "What does personalization consist of? What elements are adapted?",
    "nineteenth_text": "Kokoro Schools is a tool that allows personalization in two aspects. On the one hand, <b>personalize individual profiles</b>, selecting the language, play time limit, and regulating accessibility features such as visual and auditory stimuli. On the other hand, it allows you to <b>personalize game sessions</b>, selecting the content and specific games for each profile.",
    "twentieth_question": "How does the trial period work?",
    "twentieth_text": "The trial period lasts <b>15 days</b> from the first time you access Kokoro Schools. During this time you can access all the features we offer, creating unlimited profiles and sessions. </br>\nAfter these 15 days your plan will become limited to using a single profile and creating 3 monthly educational sessions. You can regain full access at any time by subscribing to one of our plans. </br>",
    "twenty_first_question": "Is there a free version?",
    "twenty_first_text": "Yes, it's our basic plan. This plan is limited to <b>the use of a single profile and the creation of 3 monthly educational sessions</b>. You can regain full access at any time by subscribing to one of our plans.",
    "twenty_second_question": "What happens when the trial period ends?",
    "twenty_second_text": "After the 15-day trial period, if you have not subscribed to any plan, all the profiles you have created will be locked except the first one, which you can use indefinitely in our free version.\nWith this free version you can only create 3 educational sessions per month for that same profile. </br>\n\nYou can regain full access at any time by subscribing to one of our plans.</br>",
    "twenty_third_question": "What is the price of Kokoro Schools after the trial period ends?",
    "twenty_third_text": "",
    "twenty_fourth_question": "I want to return to the experience I had with Kokoro Kids, how can I do it?",
    "twenty_fourth_text": "",
    "twenty_fifth_question": "How do I start creating a personalized session for a child?",
    "twenty_fifth_text": "Click on the student's card on the home page, you will access the child's profile and there you will find the <b>\"Create session\"</b> button (if they have no sessions created, or the previous session has already been played several times, you can access this button directly from the student card). </br>\nA session creation drawer will appear, where you can choose two ways to create that session:</br>\n\n<b> 1. Recommended session: </b> These are predefined sessions grouped by content and selected by our professionals. It is the fastest way to create sessions since by clicking one of them, you will send it directly to Kokoro Kids so your student can work on it.</br>\n\n <b> 2. Exploring all games:</b> To create a 100% custom session, this is the best way. You can filter the content depending on what you want to work on in that session. As you choose content, related games will appear. <b>You can try them or select them</b> to add them to the session cart. When you have chosen all the games you want to include in the session, in the cart you will find the \"Create session\" button, with which you can send it to Kokoro Kids for the student to work on.</br>",
    "twenty_sixth_question": "What content can I select for each child?",
    "twenty_sixth_text": "",
    "twenty_seventh_question": "What is the content of Kokoro Schools like?",
    "twenty_seventh_text": "",
    "twenty_eighth_question": "I want to limit a child's play time, how can I do it?",
    "twenty_eighth_text": "You can do it from the child's profile (by clicking on the student card) editing their profile, or from the cart while you are creating a session for that child, in the settings button. </br>\n\nWithin accessibility settings, at the bottom of profile editing, you will see the option to add a play time limit. Activate it and choose the amount of minutes you want the child to spend on that session (5, 10, 20...).</br>",
    "twenty_ninth_question": "I want to reduce visual stimuli in games for a child, how can I do it?",
    "twenty_ninth_text": "You can do it from the child's profile (by clicking on the student card) editing their profile, or from the cart while you are creating a session for that child, in the settings button.</br>\n\nWithin accessibility settings, at the bottom of profile editing, you will see the option to reduce the volume of the Kokoro Kids application's voiceover and to reduce music and sound effects volume. To disable them completely, simply move the slider to zero.</br>\nKeep in mind that the voice will not disappear completely since it is necessary for the instructions of some games.</br>",
    "thirtieth_question": "I want to disable game sounds for a child, how can I do it?",
    "thirtieth_text": "",
    "thirty_first_question": "How long does it take to create a personalized session?",
    "thirty_first_text": "",
    "thirty_second_question": "Can I add an entire group at once?",
    "thirty_second_text": "",
    "thirty_third_question": "Can I have multiple groups?",
    "thirty_third_text": "",
    "thirty_fourth_question": "Can I view sessions for an entire group at once?",
    "thirty_fourth_text": "",
    "thirty_fifth_question": "Why create a game session?",
    "thirty_fifth_text": "Play is a powerful pedagogical tool that complements classroom teaching. Creating a game session allows you to introduce new concepts dynamically, reinforce prior learning and assess knowledge in a playful way. In addition, it promotes motivation, attention and active learning, adapting to each child's pace. Using play in the classroom is as valid as using a book, a movie or any other educational resource.",
    "thirty_sixth_question": "What is a game session and how is it created?",
    "thirty_sixth_text": "It is a structured selection of interactive activities that allow you to work on specific educational objectives. It works like any other teaching resource a teacher chooses for their class, but with the advantage of adapting to each child's pace and level. To create it, you only need to <b>select the appropriate games</b> within the platform according to the content you want to work on and assign them to the children, following the desired learning progression.",
    "thirty_seventh_question": "Will I be able to see and play the games before choosing them?",
    "thirty_seventh_text": "Yes. In session creation you will see the <b>\"Try games\"</b> button, which will always be associated with each one. You can try them for as long as you want until you close them.\nKeep in mind that in this preview, these games will always start at the lowest level.",
    "thirty_eighth_question": "How can I see the games associated with each content?",
    "thirty_eighth_text": "Within session creation, when you <b>\"filter all games\"</b>, you can select content. As you select content, related games will appear, ready to be selected. </br> Games may appear whose main objective is not the one you selected, but they do work on that content. To see which content is the main one for each game, click the information symbol you will see in the upper right corner of each activity. The main content is the one marked.</br>",
    "thirty_ninth_question": "What does each content type mean on the platform?",
    "thirty_ninth_text": "Within the platform, games and activities are organized into different categories according to the skills they work on, such as executive functions, attention, perception or socio-emotional skills. To better understand each type of content, you can consult our glossary, where the development areas and their application in learning are explained.",
    "forty_fourth_question": "Is it aligned with the LOMLOE?",
    "forty_fourth_text": "Yes, the platform aligns with the principles of the LOMLOE by promoting competency-based learning, fostering personalization and inclusion. </br> Our games are designed to develop transversal skills such as problem solving, critical thinking and emotional management, key elements in the law's competency approach. </br> <br>In addition, games can be used to work on different areas of the curriculum in a playful and adapted way.</br>",
    "forty_fifth_question": "Can I include Kokoro in a learning situation?",
    "forty_fifth_text": "Including Kokoro in a learning situation is simple and effective, as it allows you to integrate resources adapted to the objectives and skills you want to reinforce in your students.</br>\n\nFor example, in a project about emotions in early childhood education, you could add an emotional identification game from Kokoro so students practice how to recognize and express feelings. The game could be an introduction or closing activity within the session, facilitating a group reflection on what was learned.</br>\n\nIn a project on mathematical problem solving in primary school, you could include a logical sequence or mental calculation game from the platform as a complementary activity. This game would reinforce the concepts covered in class in an interactive and personalized way according to each student's level.</br>\n\nKokoro Schools can be used as an autonomous resource or as a complement in learning projects and activities. Its flexibility allows you to personalize activities according to progress and individual needs, which facilitates a dynamic, student-centered learning experience.</br>",
    "forty_sixth_question": "Do you add new content?",
    "forty_sixth_text": "Yes, at Kokoro Schools <b>new content is added regularly.</b> Our team of specialists in pedagogy and educational game development continuously works to integrate new activities and keep the platform updated, so professionals always have fresh and relevant resources for their sessions.",
    "forty_seventh_question": "How much content can I add in a session?",
    "forty_seventh_text": "",
    "forty_eighth_question": "How can I see what content each game works on?",
    "forty_eighth_text": "In each game you will find an icon with the letter <b>\"i\" for information</b>. When you click it, a menu will drop down with the specific skills and content that are worked on in that game. This way you can see at a glance what pedagogical aspects are reinforced and choose the most appropriate ones according to the children's needs.",
    "forty_ninth_question": "How can I add a game to a session?",
    "forty_ninth_text": "",
    "fiftieth_question": "How do I know the level of each game?",
    "fiftieth_text": "",
    "fifty_first_question": "Is Kokoro Schools content reliable? Is it developed by specialists?",
    "fifty_first_text": "Yes, all of Kokoro's content is developed by a multidisciplinary team of specialists in psychology, pedagogy and play, design and educational game development. In addition, its effectiveness is backed by scientific research in collaboration with the <b>Polytechnic University of Valencia (UPV) and the Jaume I University (UJI)</b>, which support the use of games to develop key skills such as visual processing, memory or attention.",
    "fifty_second_question": "I want the child to play, what should I do now?",
    "fifty_second_text": "For the child to play the session you have prepared, you must have the <a href='https://kokorokids.go.link?adj_t=1l4i1na7' target='_blank'>Kokoro Kids app</a> installed on a mobile device (available on the App Store and Google Play) and sign in with the same account you use for Kokoro Schools. </br>\nWithin the Kokoro Kids app, the child can enter their profile and play the games in your session.</br>",
    "fifty_third_question": "I want to add more games, what should I do?",
    "fifty_third_text": "",
    "fifty_fourth_question": "I want to delete one or more games, what should I do?",
    "fifty_fourth_text": "",
    "fifty_fifth_question": "Can I choose the order they will play?",
    "fifty_fifth_text": "",
    "fifty_sixth_question": "How much time do you recommend for each session?",
    "fifty_sixth_text": "We recommend sessions of around <b>20 minutes a day</b>, ensuring a balanced use of screens with quality educational content. The time spent in Kokoro Schools not only entertains, but also enhances key skills in children. </br> In addition, adults can get involved in the play process, either playing with them or following their progress in the parents' area. The platform also allows you to regulate play time according to the preferences of each session.</br>",
    "fifty_seventh_question": "How are sessions organized on the child's device?",
    "fifty_seventh_text": "",
    "fifty_eighth_question": "Do I have to create a new account when I download the Kokoro Kids app?",
    "fifty_eighth_text": "No. To access the game sessions you prepare through Kokoro Schools, you must sign in to Kokoro Kids with the same account you used to create them in Kokoro Schools.</br>\nWith the same Google account, the same Apple ID or the same email and password.</br>",
    "fifty_ninth_question": "I want to name a created session, how can I do it?",
    "fifty_ninth_text": "When you finish creating the session, you will see the <b>steps you need to follow</b> afterward so the child can play it. The first of those steps, which is not mandatory, is choosing a session name. \nThese names will help you remember what that child has been working on.",
    "sixtieth_question": "How can I see the games I've chosen?",
    "sixtieth_text": "",
    "sixty_first_question": "I want to modify an active session. How can I do it?",
    "sixty_first_text": "",
    "sixty_second_question": "I want to see the child's progress after playing the games, how can I view it?",
    "sixty_second_text": "",
    "sixty_third_question": "I want to save the session to use it for several days, how can I do it?",
    "sixty_third_text": "",
    "sixty_fourth_question": "Can I modify part of the session content?",
    "sixty_fourth_text": "",
    "sixty_fifth_question": "Where are the configuration changes reflected?",
    "sixty_fifth_text": "You will see them reflected in the use of the Kokoro Kids app, where the child works on the sessions. You will also see these changes saved in the child's settings, both within Kokoro Kids and Kokoro Schools.",
    "sixty_sixth_question": "How does Kokoro Schools connect with the LEGO Foundation and its methodologies?",
    "sixty_sixth_text": "",
    "sixty_seventh_question": "What studies and scientific evidence support the effectiveness of Kokoro Schools?",
    "sixty_seventh_text": "",
    "sixty_eighth_question": "Do I need training to use Kokoro Schools?",
    "sixty_eighth_text": "",
    "sixty_ninth_question": "What are the training courses taught by Auticmo about?",
    "sixty_ninth_text": ""
  },
  "sessions": {
    "title_1": "Pre-writing",
    "subtitle_1": "Promotes early writing skills in children aged 3 to 6 using games that develop fine motor coordination, tracing shapes, numbers and letters, and creativity. Helps build a solid foundation for writing.",
    "desc_1": "Linguistic competence; perception; fine motor skills; attention; graphomotor skills; spatial orientation; creativity; social skills; symmetries; problem solving; planning.",
    "title_2": "Daily routines",
    "subtitle_2": "Learn to manage day-to-day life independently. Gain tools to plan and overcome challenges through creative strategies. This session helps familiarize and experiment with everyday activities.",
    "desc_2": "Socio-emotional; coordination; orientation; attention; personal hygiene; planning; following instructions; sequencing; laterality; directionality.",
    "title_3": "Directionality",
    "subtitle_3": "Train concepts such as up, down, left and right, forward and back, reinforcing spatial orientation and logical thinking. Understanding directionality is key to moving safely and accurately in the environment.",
    "desc_3": "Cognitive skills; logic; location; direction; spatial relations; distance; movement; symmetries; positions; planning; hand-eye coordination; orientation; laterality; coding; anticipation.",
    "title_4": "Emotional vocabulary",
    "subtitle_4": "Explore emotions. Learn to identify and name what you feel, recognize emotions in others and express them appropriately, helping emotional and social development.",
    "desc_4": "Socio-emotional skills; emotion recognition; emotional vocabulary; empathy; emotional expression; emotional regulation; perception; attention; logic; association; patterns.",
    "title_5": "Words building",
    "subtitle_5": "How are words formed? Expand basic vocabulary (animals, sports, musical instruments, food, transport, seasons, and professions) through various activities and exercises.",
    "desc_5": "Linguistic competence; grapheme-morpheme association; phonological awareness; visual discrimination; memory; basic spelling; planning; attention; perception; spelling; semantics.",
    "title_6": "Codes and patterns",
    "subtitle_6": "Games that introduce computational thinking through identifying patterns, logical sequences, and basic coding rules. Explore the logic behind codes and sequences, structuring thought, and problem solving.",
    "desc_6": "Cognitive skills; logical-mathematical; patterns; computational thinking; sequencing; attention; planning; basic programming; spatial orientation; problem solving; working memory",
    "title_7": "Attention difficulties",
    "subtitle_7": "Develop concentration and reaction ability with games that train different types of attention: sustained, divided and selective. Find hidden objects, respond quickly to stimuli and stay focused on visual and auditory challenges.",
    "desc_7": "Cognitive skills; sustained attention; divided attention; selective attention; processing speed; visual perception; stimulus discrimination; working memory; inhibitory control; association; anticipation.",
    "title_8": "Logic challenges",
    "subtitle_8": "Challenge your mind with games that train logical thinking, problem solving and planning. Solve puzzles, find patterns, draw strategic paths and face challenges that will test your deduction skills.",
    "desc_8": "Cognitive skills; reasoning; logic; problem solving; planning; strategy; association; categorization; patterns; spatial orientation; creativity; decision making.",
    "title_9": "Discover numbers",
    "subtitle_9": "Learn and reinforce numbers from 0 to 10. Counting, ordering, associating quantities and recognizing digits becomes fun with dynamic challenges that foster numerical understanding from early stages.",
    "desc_9": "Logical-mathematical; number recognition; counting; number sequences; comparison; attention; visual perception; memory; graphomotor skills; classification; association; spatial orientation.",
    "title_10": "Animal world",
    "subtitle_10": "Explore the animal kingdom and discover everything from sea dwellers to the tireless work of bees. Identify species, their habitats and what they eat while you solve memory, logic and observation challenges.",
    "desc_10": "Science; nature; classification and recognition of animals; vocabulary; attention; visual memory; association; fine motor skills; ecological awareness; logic; relaxation; orientation."
  },
  "common": {
    "back": "Back",
    "continue": "Continue",
    "close": "Close",
    "done": "Done",
    "attention": "Attention",
    "later": "Later",
    "goBack": "Go back",
    "save": "Save",
    "cancel": "Cancel",
    "accept": "Accept",
    "applyChanges": "Apply changes",
    "finish": "Finish",
    "update": "Update",
    "remove": "Remove",
    "new": "NEW",
    "or": "or",
    "month": "Month",
    "year": "Year",
    "language": "Language",
    "chooseOption": "Choose an option",
    "chooseLanguage": "Choose a language",
    "yes": "Yes",
    "no": "No",
    "notSure": "Not sure",
    "preferNotToAnswer": "Prefer not to answer",
    "daysCount": "{count} days",
    "days": "days",
    "minutesCount": "{count} minutes",
    "yearsCount": "{count} years",
    "search": "Search",
    "help": "Help",
    "confirmGoBack": "Are you sure you want to go back?",
    "years": "years"
  },
  "auth": {
    "noAccount": "Don't have an account yet?",
    "alreadyHaveAccount": "I already have an account",
    "alreadyHaveAccountQuestion": "Already have an account?",
    "almostThere": "Almost there!",
    "sessionExpired": "Session expired",
    "logout": "Sign out",
    "signupError": "Error registering a new user",
    "email": "Email",
    "password": "Password",
    "repeatPassword": "Repeat password",
    "whoAreYou": "Who are you?",
    "otherRole": "Other, which?",
    "createAccount": "Create new account",
    "signInWithGoogle": "Sign in with Google",
    "signInWithApple": "Sign in with Apple",
    "signUpWithGoogle": "Sign up with Google",
    "signUpWithApple": "Sign up with Apple",
    "signInWithEmail": "Sign in with email and password",
    "signUpWithEmail": "Sign up with email and password",
    "transformEducation": "Your power to transform education",
    "recoverPassword": "RECOVER PASSWORD",
    "forgotPassword": "I forgot my password",
    "register": "Sign up",
    "signIn": "Sign in",
    "confirmSignOut": "Are you sure you want to sign out of Kokoro Schools?",
    "userTypes": {
      "teacher": "Teacher",
      "psychologist": "Psychologist",
      "mother": "Mother",
      "father": "Father",
      "familyTutor": "Family member",
      "other": "Other"
    }
  },
  "snackbar": {
    "initDataError": "Error loading app startup data",
    "signupExistingUserLogin": "This user already exists. Sign in with your password",
    "signupCreateUserError": "Error creating user",
    "loginInvalidCredentials": "Sign-in error. Make sure you entered your password correctly",
    "googleSignInError": "Error signing in with Google",
    "appleSignInError": "Error signing in with Apple",
    "emailUserAlreadyExists": "User already exists",
    "emailSignUpError": "Error signing up",
    "customTokenSignInError": "Error signing in with custom token",
    "recoverPasswordEmailSent": "We sent you an email to recover your password",
    "recoverPasswordEmailError": "Error sending password recovery email",
    "gamesScheduledSessionsError": "Error getting scheduled game sessions",
    "allGamesScheduledSessionsError": "Error getting all scheduled game sessions",
    "sendGamesError": "Error sending games",
    "onboardingCheckLearnerName": "Check your learner's name",
    "onboardingCreateUserError": "There was an error creating your user"
  },
  "validation": {
    "requiredMonth": "Month is required",
    "requiredYear": "Year is required",
    "requiredOption": "An option is required",
    "requiredLanguage": "Language is required",
    "requiredPrefix": "Prefix is required",
    "requiredCenterType": "Center type is required",
    "requiredSpecialNeeds": "Special need is required",
    "invalidEmail": "This email is not valid. Make sure you typed it correctly.",
    "invalidPassword": "Password is not valid",
    "nameMinLength": "Name must have at least one character",
    "nameInvalidChars": "Name contains invalid characters",
    "passwordsMustMatch": "Passwords must match",
    "selectProfile": "Select your profile",
    "sessionNameTooLong": "Session name cannot exceed 20 characters.",
    "selectSpecialNeed": "Select a special need option",
    "selectTimeLimitMinutes": "Select minutes for the time limit",
    "selectProfessionalType": "Select your professional type and create your account"
  },
  "profile": {
    "changeSelectionWarning": "Your current selection will be cleared. Are you sure you want to select another profile?",
    "changeSelectionWarningWithSession": "All games in the current profile session will be removed. Are you sure you want to select another profile?",
    "discardChangesPrompt": "Do you want to go back without applying the changes?",
    "profileImage": "Profile image",
    "settingsFor": "Settings for {name}",
    "profile": "Profile",
    "changeImage": "Change image",
    "name": "Name",
    "birthDate": "Birth date",
    "birthMonth": "Birth month",
    "birthYear": "Birth year",
    "hasSpecialNeeds": "Does the student have special needs?",
    "whichSpecialNeeds": "Which special needs?",
    "whichSpecialNeedsShort": "Which?",
    "learningLanguage": "Learning language",
    "whichNeed": "Which need?",
    "prefix": "Prefix",
    "centerType": "Work center type",
    "phone": "Phone",
    "learnerName": "Student name",
    "learnerBirthDate": "When was your student born?",
    "hasSpecificSupportNeeds": "Do they have specific educational support needs?",
    "changePhoto": "Change photo",
    "saveProfile": "Save profile",
    "editProfile": "Edit profile",
    "lockedProfile": "Profile locked",
    "addProfile": "Add profile",
    "configureProfile": "CONFIGURE PROFILE",
    "settings": "Settings",
    "progress": "Progress",
    "createLearnerProfile": "CREATE STUDENT PROFILE",
    "unsavedChangesWarning": "Unsaved changes will be cleared. Are you sure you want to select another profile?",
    "downloadProgressPrompt": "To see {name}'s progress, download the Kokoro Kids app and sign in with the email",
    "signInWithEmail": "with the email {email}",
    "changeLanguage": "Change language"
  },
  "accessibility": {
    "title": "Accessibility settings",
    "audio": "Audio",
    "voice": "Voice",
    "musicAndSfx": "Music & SFX",
    "reduceVisualStimuli": "Reduce visual stimuli",
    "timeLimit": "Play time limit",
    "minutes": "minutes",
    "chooseTime": "Choose time",
    "voiceVolume": "Voice volume",
    "musicAndSfxVolume": "Music and sound effects volume",
    "noSettingsSelected": "No accessibility settings",
    "configure": "Configure accessibility"
  },
  "specialNeeds": {
    "preferNotToAnswer": "Prefer not to answer",
    "tea": "ASD",
    "tps": "TPS",
    "di": "DI",
    "ac": "AC",
    "tdah": "ADHD",
    "other": "Other",
    "downSyndrome": "Down syndrome",
    "intellectualDisability": "Intellectual disability",
    "highAbilities": "High abilities",
    "languageDisorder": "Specific language disorder",
    "dyslexia": "Dyslexia",
    "dyscalculia": "Dyscalculia"
  },
  "languages": {
    "spanish": "Spanish",
    "english": "English",
    "portuguese": "Portuguese",
    "indonesian": "Indonesian",
    "unknown": "Unknown language"
  },
  "months": {
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December"
  },
  "menu": {
    "home": "Home",
    "profile": "Profile",
    "faq": "FAQ"
  },
  "plans": {
    "upgradePlan": "Upgrade plan",
    "currentPlanTitle": "This is your current Kokoro Schools plan:",
    "upgradePrompt": "Do you want to take your educational experience to the next level?",
    "basic": "BASIC PLAN",
    "professional": "PROFESSIONAL PLAN",
    "schools": "SCHOOLS PLAN",
    "freePrice": "FREE",
    "proPrice": "€111/year",
    "customPrice": "CUSTOM PRICE",
    "continueFree": "Continue free",
    "upgradeMyPlan": "Upgrade my plan",
    "requestPlan": "Request this plan",
    "discountBadge": "20% OFF",
    "activeSubscription": "Active subscription",
    "limitedVersion": "Limited version",
    "trialPeriod": "TRIAL PERIOD",
    "expiresIn": "Expires in",
    "trialExpired": "TRIAL PERIOD EXPIRED",
    "nextRenewalIn": "Next renewal in",
    "viewPlans": "View plans",
    "trialEndsIn": "Your trial period ends in {count} days",
    "upgradeForUnlimited": "Upgrade your plan to access unlimited profiles and sessions",
    "tiers": {
      "basic": "BASIC",
      "trial": "TRIAL",
      "professional": "PROFESSIONAL",
      "schools": "SCHOOLS"
    },
    "features": {
      "free": {
        "profile": "1 student profile",
        "sessions": "3 monthly learning sessions",
        "games": "Over 200 games to choose from"
      },
      "pro": {
        "profiles": "3 profiles",
        "unlimitedSessions": "Unlimited sessions",
        "timeSettings": "Play time settings",
        "games": "Over 200 games to choose from",
        "gameCreator": "Game creator (coming soon)",
        "premiumAccess": "Access to Kokoro Kids Premium"
      },
      "expert": {
        "limitedProfiles": "Limited profiles",
        "unlimitedSessions": "Unlimited sessions",
        "professionalProgram": "Professional development program",
        "timeSettings": "Play time settings",
        "games": "Over 200 games to choose from",
        "gameCreator": "Game creator (coming soon)",
        "premiumAccess": "Access to Kokoro Kids Premium"
      }
    },
    "popup": {
      "features": {
        "unlimitedProfiles": "Unlimited profiles and groups",
        "unlimitedSessions": "Unlimited sessions",
        "premiumKids": "Kokoro Kids premium",
        "activityBook": "Activity book"
      }
    }
  },
  "session": {
    "subtitle": {
      "selectActivities": "Select activities",
      "chooseSubcategories": "Choose subcategories",
      "chooseObjectives": "Choose objectives"
    },
    "create": "Create session",
    "selectGamesPrompt": "Choose the games to create the learning session",
    "activitiesCount": "({count} activity) | ({count} activities)",
    "confirmDeleteSession": "Are you sure you want to delete this game session?",
    "resetAllGames": "All games in the session will be removed",
    "confirmRedoSession": "Are you sure you want to redo the session?",
    "confirmSendSession": "Are you sure you want to send this session to the app?",
    "noActivitiesSelected": "You haven't selected activities for this student yet",
    "startNow": "START NOW",
    "planNewSession": "Plan a new session",
    "redoSession": "Redo session",
    "addMoreActivities": "Add more activities",
    "sendSessionToLearner": "Send session to student",
    "monthlyLimitTitle": "You've reached the monthly session limit",
    "monthlyLimitSubtitle": "Unlock unlimited sessions with our plans",
    "sessionDataTitle": "Learning session data",
    "selectedGamesCount": "{count} games selected",
    "gamesComingSoon": "Games for {objectives} coming soon",
    "confirmSendYes": "Yes, send session",
    "confirmSendNo": "No, keep exploring",
    "recommendedTitle": "Recommended sessions",
    "recommendedDescription": "Selection of sessions designed for common topics, adapted to students' needs.",
    "customTitle": "Create your session",
    "customDescription": "Customize your session by choosing games and objectives that best fit your students and your teaching style.",
    "createHowTitle": "How do you want to create the session?",
    "active": "Active session",
    "previous": "Previous sessions",
    "activeInKokoroKids": "ACTIVE SESSION IN KOKORO KIDS",
    "previousInKokoroKids": "PREVIOUS SESSIONS IN KOKORO KIDS",
    "defaultName": "Session name",
    "createdOn": "CREATED {date}",
    "viewActivities": "View activities",
    "playNow": "PLAY NOW!",
    "timesPlayed": "Times played",
    "noGamesSelected": "No games selected",
    "addGame": "Add game",
    "tryGame": "Try game",
    "filterGames": "Filter games",
    "filterAllGames": "Filter all games ({count})",
    "clearAllFilters": "Clear all filters",
    "play": "Play",
    "playedLabel": "Played",
    "createdOnLabel": "Created",
    "playedTimes": "Played {count} times",
    "sessionInLanguage": "Session in {language}",
    "noSessions": "No sessions",
    "createFirstSessionPrompt": "No sessions yet, create the first one!",
    "pendingToPlay": "Pending to play",
    "howToPlay": "How can I play?",
    "namePlaceholder": "Type the session name here",
    "viewGames": "View games",
    "viewContent": "View content"
  },
  "sessionRecommendation": {
    "title": "Session recommendation",
    "subtitle": "Here are some sessions you might like:",
    "viewGames": "View games",
    "chooseSession": "Choose session",
    "gamesCount": "{count} games"
  },
  "profiles": {
    "congratsTitle": "Congratulations!",
    "congratsMessage": "You successfully created {name}'s profile. Start creating a personalized learning session by clicking it.",
    "groupTitle": "YOUR GROUP",
    "groupSubtitle": "Customize the session per student",
    "preparingSession": "We're preparing your session",
    "manageGroup": "Manage your group"
  },
  "onboard": {
    "welcomeTitle": "Welcome, you're now inside Kokoro Schools!",
    "subtitle": "Explore how Kokoro Schools works and take your first steps:",
    "alreadyPlayed": "Already played?",
    "unlockLink": "Click here and unlock the rest of Kokoro Schools.",
    "register": {
      "title": "Register your first student",
      "description": "Learning sessions are tailored to each student, start with this step.",
      "createLearner": "Create student",
      "addLearner": "Add student",
      "addTestLearner": "Add test student",
      "sampleLaraName": "Lara",
      "sampleNoaName": "Noa"
    },
    "play": {
      "title": "Time to play!",
      "description": "Download or open the app and play the planned session.",
      "prompt": "To play the session, download the app and sign in with the email you used to register."
    },
    "learning": {
      "title": "Create your first learning session",
      "description": "Select games and adapt the session for the first student."
    }
  },
  "onboarding": {
    "welcomeTitle": "Welcome to Kokoro Schools!",
    "welcomeSubtitle": "You can now start personalizing your learning sessions in minutes!",
    "aboutProfessional": "Tell us about yourself as a professional",
    "noMarketing": "I don't want to receive news, promotions, or free content from Kokoro.",
    "createFirstProfileTitle": "Let's create the first profile for one of your students.",
    "createFirstProfileSubtitle": "Enter their name to start creating sessions in Kokoro Kids",
    "languageQuestion": "Do you want them to learn in their native language, or another one?",
    "languageSubtitle": "Kokoro Kids activities will be shown in the language you want them to practice.",
    "accessibilityQuestion": "Do you want to configure accessibility?",
    "accessibilitySubtitle": "Based on their needs you can reduce visual and auditory stimuli, and add a play time limit.",
    "beginTitle": "We're ready to start!",
    "beginSteps": {
      "createSession": "CREATE THE FIRST LEARNING SESSION IN KOKORO SCHOOLS",
      "downloadApp": "DOWNLOAD KOKORO KIDS ON THE TABLET / SMARTPHONE",
      "signIn": "SIGN IN WITH THIS ACCOUNT IN KOKORO KIDS",
      "startLearning": "THEY CAN NOW START LEARNING WITH YOUR PERSONALIZED SESSION!"
    },
    "letsGo": "LET'S GO!"
  },
  "home": {
    "discountTitle": "Take advantage of the 20% discount!",
    "discountSubtitle": "Get unlimited access to all benefits of Kokoro Schools plans",
    "profileLimitTitle": "You've reached the limit of profiles you can create",
    "profileLimitSubtitle": "Unlock unlimited profiles with our plans",
    "greeting": "Hi, great to see you here!",
    "goToKokoroKids": "Go to Kokoro Kids",
    "createLearner": "Create student"
  },
  "faq": {
    "titleShort": "FAQ",
    "title": "Frequently asked questions",
    "description1": "Find answers to the most common questions about Kokoro Schools.",
    "description2": "We want your experience to be as clear and simple as possible, so we've gathered the most important information for you.",
    "contactPrompt": "Do you have more questions or suggestions?",
    "contactUs": "Contact us"
  },
  "help": {
    "needHelp": "Need help?",
    "description": "We're here to help you resolve your questions. Contact our Kokoro Schools team",
    "contact": "Contact"
  },
  "brand": {
    "kokoroKids": "KOKORO KIDS"
  },
  "loginPopup": {
    "title": "Do you want to use Kokoro Kids with the benefits of Kokoro Schools?",
    "benefits": {
      "customize": "CUSTOMIZE YOUR CLASSES",
      "prepareQuickly": "PREPARE SESSIONS IN LESS THAN A MINUTE",
      "adaptContent": "ADAPT CONTENT TO THE STUDENT'S NEEDS"
    },
    "talk": "SHALL WE TALK?",
    "requestAccess": "Request access",
    "emailSubject": "Request access to Kokoro Schools",
    "emailBody": "Hi, I'd like to get access to Kokoro Schools."
  },
  "qrPopup": {
    "scanTitle": "Scan this QR code from any mobile device",
    "scanSubtitle": "to download or start using Kokoro Kids.",
    "readyToUse": "You can now use",
    "downloadOrUseNow": "Download it or start using it right away.",
    "useOnThisDevice": "USE ON THIS DEVICE",
    "useOnOtherDevice": "USE ON ANOTHER DEVICE",
    "manualSignIn": "You can also sign in to the app manually with the same account"
  },
  "payment": {
    "successTitle": "Subscription active!",
    "errorTitle": "Oops!",
    "successSubtitle": "Congratulations!",
    "errorSubtitle": "It looks like something went wrong.",
    "successDetails": "You can now enjoy the benefits of your subscription.",
    "errorDetails": "Check that the information you entered is correct.",
    "continueCreatingSessions": "Keep creating sessions",
    "backToPlans": "Back to plans"
  },
  "sessionCreated": {
    "title": "Follow these simple steps so {name} can start playing!",
    "defaultSessionName": "Learning session",
    "signIn": "Sign in",
    "signInPrompt": "in the app with the same account.",
    "yourUser": "Your user:",
    "profilePrompt": "In the app, {name}'s profile will appear. Select it and the session will be ready to",
    "play": "play",
    "nameSession": "Name",
    "nameSessionPrompt": "this play session for {name}",
    "nameSessionHelp": "This will help you remember the contents the session is working on.",
    "nameSessionPlaceholder": "Type a session name",
    "download": "Download",
    "downloadPrompt": "the app on the tablet or phone where {name} will play.",
    "scanQr": "You can do it by scanning this QR",
    "openAppPrompt": "Click this button to open the app",
    "openApp": "Open the app",
    "searchInStoresPrefix": "Or search for",
    "searchInStoresSuffix": "on Google Play or the App Store."
  },
  "centerTypes": {
    "publicSchool": "Public school",
    "charterSchool": "Charter school",
    "privateSchool": "Private school",
    "specialEducationSchool": "Special education school",
    "psychologicalOffice": "Psychological office",
    "pedagogicalClinic": "Pedagogical clinic",
    "other": "Other"
  },
  "groups": {
    "sample": {
      "squirrel": "Squirrel class",
      "gorilla": "Gorilla class",
      "snail": "Snail class",
      "sessionTitle1": "Discrimination session - Feb 5",
      "sessionDate1": "February 12, 2024",
      "sessionDuration": "10 minutes"
    }
  },
  "routes": {
    "createSession": "Create session",
    "sessionCreated": "Session created successfully",
    "plans": "Plans",
    "editProfile": "Edit profile",
    "subscriptionActivated": "Subscription activated",
    "operationCanceled": "Operation canceled",
    "maintenance": "Maintenance"
  }
}
